import { ReactNode } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { SidebarDivider } from '@backstage/core-components';

const useStyles = makeStyles<Theme>(() => ({
  footerWrapper: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

export type SidebarFooterProps = {
  children: ReactNode;
};

export const SidebarFooter = ({ children }: SidebarFooterProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.footerWrapper}>
      <SidebarDivider />
      {children}
    </Box>
  );
};
